<template>
  <div class="field-icon-edit position-relative" :class="{ 'readonly-field': calculated }">
    <!-- Botón de lock/unlock para campos safe (solo si no está deshabilitado) -->
    <div v-if="field.safe && !disableLock" class="float-left">
      <button
        v-if="isLocked"
        type="button"
        class="btn btn-sm btn-outline-secondary border-0 buttonn-lock"
        @click="unlockField"
      >
        <i class="material-icons">lock</i>
      </button>
      <button
        v-else
        type="button"
        class="btn btn-outline-primary btn-sm border-0 buttonn-lock"
        @click="lockField"
      >
        <i class="material-icons">lock_open</i>
      </button>
    </div>

    <div class="icon-selector">
      <div class="d-flex flex-wrap">
        <span
          v-for="icon in availableIcons"
          :key="icon"
          class="icon-select-option"
          :class="{
            selected: displayValue === icon,
            disabled: field.readonly || isLocked,
          }"
          @click="!field.readonly && !isLocked && onFieldChange(icon)"
          :style="{
            cursor: field.readonly || isLocked ? 'not-allowed' : 'pointer',
            margin: '4px',
            padding: '6px',
            borderRadius: '6px',
            border: displayValue === icon ? '2px solid var(--bs-primary)' : '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            opacity: field.readonly || isLocked ? 0.6 : 1,
          }"
        >
          <i
            class="material-icons"
            :style="{
              fontSize: '28px',
              color: displayValue === icon ? 'var(--bs-primary)' : '#888',
            }"
            >{{ icon }}</i
          >
          <span
            v-if="displayValue === icon"
            style="margin-left: 4px; color: var(--bs-primary)"
            >✔</span
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditFieldIcon",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    defaultIcons: {
      type: Array,
      default: () => [],
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activelyEditing: false,
    };
  },
  computed: {
    availableIcons() {
      if (this.field.icons && Array.isArray(this.field.icons) && this.field.icons.length > 0) {
        return this.field.icons;
      }
      if (this.defaultIcons && Array.isArray(this.defaultIcons) && this.defaultIcons.length > 0) {
        return this.defaultIcons;
      }
      return [
        "home", "settings", "person", "group", "folder", "file", "image", "video",
        "music", "star", "favorite", "bookmark", "share", "download", "upload",
        "delete", "edit", "add", "remove", "check", "close", "arrow_back",
        "arrow_forward", "arrow_upward", "arrow_downward",
      ];
    },
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      if (this.field.defaultValue !== undefined && this.field.defaultValue !== null) {
        return this.field.defaultValue;
      }
      return null;
    },
    computedFieldId() {
      return this.fieldId || `field-icon-${this.field.key}`;
    },
    isLocked() {
      if (this.activelyEditing) {
        return false;
      }
      if (!this.value) {
        return false;
      }
      if (this.field.safe && this.editingFields !== this.field.key) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onFieldChange(newValue) {
      this.activelyEditing = true;
      this.$emit("input", newValue);
    },
    onBlur() {
      if (this.field.safe && this.editingFields !== this.field.key) {
        this.activelyEditing = false;
      }
    },
    onFocus() {
      if (this.field.safe && this.editingFields !== this.field.key) {
        this.activelyEditing = true;
      }
    },
    lockField() {
      this.$emit("update:editingFields", "");
      this.activelyEditing = false;
    },
    unlockField() {
      this.$emit("update:editingFields", this.field.key);
      this.activelyEditing = true;
    },
  },
};
</script>

<style scoped>
.field-icon-edit {
  width: 100%;
}

.icon-selector {
  width: 100%;
}

.icon-select-option {
  transition: all 0.2s ease;
}

.icon-select-option:hover:not(.disabled) {
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.icon-select-option.selected {
  background-color: #e3f2fd;
}

.icon-select-option.disabled {
  cursor: not-allowed !important;
}

</style>

